import JobTableFilter from "./job-table-filter";


const JobFilters = {
    Table: JobTableFilter
}

export default JobFilters;